import React from 'react';
import './App.css';
import ReactCardFlip from 'react-card-flip';
import Topbar from './Topbar';
import Footer from './Footer';
import { AnimatePresence, motion } from 'framer-motion';

class FAQ extends React.Component {

    constructor() {
        super();
        this.state = {
            q1: false,
            q2: false,
            q3: false,
            q4: false,
            q5: false,
            q6: false,
            q7: false,
            q8: false,
            q9: false,
            q10: false
        };
        this.q1Flip = this.q1Flip.bind(this);
        this.q2Flip = this.q2Flip.bind(this);
        this.q3Flip = this.q3Flip.bind(this);
        this.q4Flip = this.q4Flip.bind(this);
        this.q5Flip = this.q5Flip.bind(this);
        this.q6Flip = this.q6Flip.bind(this);
        this.q7Flip = this.q7Flip.bind(this);
        this.q8Flip = this.q8Flip.bind(this);
        this.q9Flip = this.q9Flip.bind(this);
        this.q10Flip = this.q10Flip.bind(this);
    }

    q1Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q1: !prevState.q1 }));
    }

    q2Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q2: !prevState.q2 }));
    }

    q3Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q3: !prevState.q3 }));
    }

    q4Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q4: !prevState.q4 }));
    }

    q5Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q5: !prevState.q5 }));
    }

    q6Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q6: !prevState.q6 }));
    }

    q7Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q7: !prevState.q7 }));
    }

    q8Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q8: !prevState.q8 }));
    }

    q9Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q9: !prevState.q9 }));
    }

    q10Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q10: !prevState.q10 }));
    }

    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q1} flipDirection="vertical">
                            <button onClick={this.q1Flip} className="faq-card">
                                <div className="faq-question">
                                    What is psychotherapy and how can it help?
                                </div>
                            </button>

                            <button onClick={this.q1Flip} className="faq-card2">
                                <div className="faq-answer">
                                    Psychotherapy, often referred to as “talk therapy,” is a form of mental health treatment that helps
                                    individuals improve their emotional wellbeing, manage stress, and navigate life challenges. Working
                                    with a psychotherapist or social worker, you can explore your thoughts, feelings, and behaviours in a
                                    safe, supportive environment. Psychotherapy can help reduce symptoms of anxiety and depression,
                                    process past trauma, improve coping skills, and support personal growth and resilience.                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q2} flipDirection="vertical">
                            <button onClick={this.q2Flip} className="faq-card">
                                <div className="faq-question">
                                    Do I need a referral to see a psychotherapist in Ontario?
                                </div>
                            </button>

                            <button onClick={this.q2Flip} className="faq-card2">
                                <div className="faq-answer">
                                    No referral is required to access psychotherapy in Ontario—you can book directly. With your consent,
                                    your therapist can collaborate with other healthcare providers if needed. However, in some cases, a
                                    referral from your family doctor may be required by your health insurance provider in order to receive
                                    reimbursement for services.                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q3} flipDirection="vertical">
                            <button onClick={this.q3Flip} className="faq-card">
                                <div className="faq-question">
                                    How do I get
                                    started with therapy?
                                </div>
                            </button>

                            <button onClick={this.q3Flip} className="faq-card2">
                                <div className="faq-answer">
                                    Getting started is simple. You can fill out our contact form, email us, or call/text to book a free 15-
                                    minute consultation. We’ll learn about your needs and help match you with the right therapist—there’s
                                    no obligation to continue.                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q4} flipDirection="vertical">
                            <button onClick={this.q4Flip} className="faq-card">
                                <div className="faq-question">
                                    Is psychotherapy difficult or
                                    uncomfortable?
                                </div>
                            </button>

                            <button onClick={this.q4Flip} className="faq-card2">
                                <div className="faq-answer">
                                    Psychotherapy can feel uncomfortable at times, as it may involve exploring difficult emotions,
                                    memories, or parts of yourself you’ve been avoiding. However, working with a psychotherapist or social
                                    worker can help you build coping skills, improve relationships, and gain self-awareness. Over time, many

                                    people experience reduced anxiety, depression, and trauma-related symptoms, along with greater
                                    emotional resilience.
                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q5} flipDirection="vertical">
                            <button onClick={this.q5Flip} className="faq-card">
                                <div className="faq-question">
                                    What can I expect from a psychotherapy session?
                                </div>
                            </button>

                            <button onClick={this.q5Flip} className="faq-card2">
                                <div className="faq-answer">
                                    Your first psychotherapy session typically lasts 60–75 minutes and focuses on getting to know you and
                                    your concerns. A psychotherapist or social worker will ask about your current challenges, personal
                                    history, relationships, and your physical and emotional health. You’ll also begin discussing your goals for
                                    therapy and what you hope to achieve, helping guide a personalized treatment plan. Ongoing sessions
                                    are typically 50 minutes and focus on your treatment plan. Your therapist uses approaches tailored to
                                    your needs to help you build skills and work toward your goals.                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q6} flipDirection="vertical">
                            <button onClick={this.q6Flip} className="faq-card">
                                <div className="faq-question">
                                    Do you offer virtual psychotherapy
                                    sessions in Ontario?
                                </div>
                            </button>

                            <button onClick={this.q6Flip} className="faq-card2">
                                <div className="faq-answer">
                                    Yes, we offer both in-person (in Kingston  Toronto coming soon!) and virtual psychotherapy sessions.
                                    Online therapy is provided through secure, PIPEDA- and PHIPA-compliant video platforms such as Zoom
                                    or Jane. Virtual sessions offer convenient access to care, and any considerations can be discussed during
                                    your initial consultation.                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q7} flipDirection="vertical">
                            <button onClick={this.q7Flip} className="faq-card">
                                <div className="faq-question">
                                    Are psychotherapy services covered
                                    by insurance in Ontario?
                                </div>
                            </button>

                            <button onClick={this.q7Flip} className="faq-card2">
                                <div className="faq-answer">
                                    Many extended health benefit plans cover services provided by a Registered Psychotherapist (RP) or
                                    Registered Social Worker (RSW). Coverage varies by provider, so it’s important to check with your
                                    insurance company to confirm eligibility and reimbursement amounts. Please note that we offer limited
                                    direct billing, and clients pay upfront and submit receipts for reimbursement.                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q8} flipDirection="vertical">
                            <button onClick={this.q8Flip} className="faq-card">
                                <div className="faq-question">
                                    What are your psychotherapy fees
                                    and payment options?
                                </div>
                            </button>

                            <button onClick={this.q8Flip} className="faq-card2">
                                <div className="faq-answer">
                                    Fees for psychotherapy services vary by therapist and level of experience. Fees are listed beside each
                                    therapist’s name in our “Therapists” section of the website. We offer a limited sliding scale for clients
                                    experiencing financial hardship—please contact us before your first session to discuss availability.                                    <br /><br />
                                    Payment is required at each session and can be made by credit card or e-transfer to
                                    payment@talltreepsychotherapy.ca. Receipts are provided by email for insurance reimbursement.                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q9} flipDirection="vertical">
                            <button onClick={this.q9Flip} className="faq-card">
                                <div className="faq-question">
                                    What is your psychotherapy cancellation policy?
                                </div>
                            </button>

                            <button onClick={this.q9Flip} className="faq-card2">
                                <div className="faq-answer">
                                    We require at least 24 hours’ notice to cancel or reschedule a psychotherapy session. Cancellations with
                                    less than 24 hours’ notice or missed appointments are subject to a $50 cancellation or no-show fee.

                                    Fees may be waived in cases of medical or family emergencies, or severe weather conditions. You can
                                    cancel by phone/text (647-457-2566), email your therapist directly or email
                                    info@talltreepsychotherapy.ca.                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                        <ReactCardFlip isFlipped={this.state.q10} flipDirection="vertical">
                            <button onClick={this.q10Flip} className="faq-card">
                                <div className="faq-question">
                                    Is my information kept confidential in
                                    psychotherapy?
                                </div>
                            </button>

                            <button onClick={this.q10Flip} className="faq-card2">
                                <div className="faq-answer">
                                    Yes, all information shared in psychotherapy is kept strictly confidential. Your therapist will not release
                                    any information to a third party without your written consent, which you can update or withdraw at any
                                    time.
                                    There are some legal and ethical limits to confidentiality, which will be clearly explained in your
                                    informed consent form and reviewed with you during your first session.                                </div>
                            </button>
                        </ReactCardFlip>
                    </div>
                </div>
            </motion.div>
        )
    }
}

export default FAQ;

/*
                <div>
                    <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q1} flipDirection="vertical">
                        <button onClick={this.q1Flip} className="faq-card">
                            <div className="faq-question">
                                What is your dog's name?
                            </div>
                        </button>

                        <button onClick={this.q1Flip} className="faq-card2">
                            <div className="faq-answer">
                                My dog's name is Mara. She is a good doggy.
                            </div>
                        </button>
                    </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q2} flipDirection="vertical">
                        <button onClick={this.q2Flip} className="faq-card">
                            <div className="faq-question">
                                What is your cat's name?
                            </div>
                        </button>

                        <button onClick={this.q2Flip} className="faq-card2">
                            <div className="faq-answer">
                                My cat's name is Georgia. She is a good kitty cat.
                            </div>
                        </button>
                    </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q3} flipDirection="vertical">
                        <button onClick={this.q3Flip} className="faq-card">
                            <div className="faq-question">
                                What does a very long question with a lot of words look like with this layout?
                            </div>
                        </button>

                        <button onClick={this.q3Flip} className="faq-card2">
                            <div className="faq-answer">
                            Psychotherapy (also psychological therapy or talking therapy) is the use of psychological methods, particularly when based on regular personal interaction with adults, to help a person change behavior and overcome problems in desired ways. Psychotherapy aims to improve an individual's well-being and mental health, to resolve or mitigate troublesome behaviors, beliefs, compulsions, thoughts, or emotions, and to improve relationships and social skills.
                            </div>
                        </button>
                    </ReactCardFlip>
                    </div>
                    <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q4} flipDirection="vertical">
                        <button onClick={this.q4Flip} className="faq-card">
                            <div className="faq-question">
                                Who is Jake Briltz?
                            </div>
                        </button>

                        <button onClick={this.q4Flip} className="faq-card2">
                            <div className="faq-answer">
                                Jake Briltz is the coolest guy I know.
                            </div>
                        </button>
                    </ReactCardFlip>
                    </div>
                </div>
                */